// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1U-8X","left":"styles_left__3ek9n"};